<script setup>
// This screen manages the section navigation between MyModelPortfolio and ModelPortfolioInvestmentVehicles
import { ref } from 'vue';
import MyModelPortfolioTab from "@/tabs/user-dashboard/MyModelPortfolio.vue";
import ModelPortfolioInvestmentVehiclesTab from "@/tabs/user-dashboard/ModelPortfolioInvestmentVehicles.vue";

const currentSection = ref(1); // 1 = MyModelPortfolio, 2 = ModelPortfolioInvestmentVehicles

const setSection = (sectionId) => {
  currentSection.value = sectionId;
};
</script>

<template>
  <!-- Section 1: My Model Portfolio -->
  <MyModelPortfolioTab
    v-if="currentSection === 1"
    :setSection="setSection"
  />

  <!-- Section 2: Investment Vehicles -->
  <ModelPortfolioInvestmentVehiclesTab
    v-else-if="currentSection === 2"
    :setSection="setSection"
  />
</template>
